import React from "react";

import { css } from "@emotion/css";

import { useStyles } from "@/hooks/useStyles.ts";
import { PatientMonitoring } from "@/pages/patient-monitoring/PatientMonitoring.tsx";
import { PageContent } from "@/uiKit/atoms/page/PageContent.tsx";

export const PatientMonitoringPage: React.FC = () => {
  const styles = useStyles(makeStyles);

  return (
    <PageContent id="patient-monitoring-page" className={styles.content}>
      <PatientMonitoring />
    </PageContent>
  );
};

const makeStyles = () => ({
  container: css({}),
  content: css({
    paddingTop: "2vh",
  }),
});
